import "./dashboardWidget.scss";

const DashboardWidget = ({ title, value, secondary, icon }) => {
    return (
        <div className="dashboardWidget">
            <div className="left">
                <span className="title">{title}</span>
                <span className="counter">{value}</span>
                {secondary && <span className="secondary">{secondary}</span>}
            </div>
            <div className="right">
                {icon}
            </div>
        </div>
    );
};

// Skeleton component for loading state
DashboardWidget.Skeleton = () => (
    <div className="dashboardWidget">
        <div className="left">
            <div className="title-skeleton" />
            <div className="counter-skeleton" />
        </div>
        <div className="right">
            <div className="icon-skeleton" />
        </div>
    </div>
);

export default DashboardWidget;